// Supervisory Review section form field enum
export enum SupervisoryReviewFormField {
  ID_BADGE = 'supervisoryReview/idBadge',
  HONORING_RIGHTS = 'supervisoryReview/honoringRights',
  EMERGENCY_PROTOCOL = 'supervisoryReview/emergencyProtocol',
  HYGIENE_PRECAUTIONS = 'supervisoryReview/hygienePrecautions',
  REPORTING_CHANGES = 'supervisoryReview/reportingChanges',
  GRIEVANCE_COMPLAINT = 'supervisoryReview/grievanceComplaint',
  POC_DOC_REVIEWED_WITH_CAREGIVER = 'supervisoryReview/pocDocReviewedWithCaregiver',
  PPE_ACCESS = 'supervisoryReview/ppeAccess',
  SUPERVISION_OBSERVED = 'supervisoryReview/supervisionObserved',
  TASK_OBSERVED = 'supervisoryReview/taskObserved',
  PATIENT_STATUS = 'supervisoryReview/patientStatus',
  COMMENTS = 'supervisoryReview/comments',
  EDUCATION_CAREGIVER_EDUCATION_TOPIC = 'supervisoryReview/education/caregiverEducationTopic',
  EDUCATION_EDUCATION_PROVIDED = 'supervisoryReview/education/educationProvided',
  INITIALS_AUTHORIZATION = 'supervisoryReview/initialsAuthorization'
}
